<script>
import { useMailV2Store } from '../../stores/mailV2'
import EcComboSelect from '../ui/EcComboSelect.vue'

function getTranslatable(val, locale) {
  if (!val) return ''
  if (typeof val === 'string') return val
  return val[locale] || val.fr || val.en || Object.values(val).find(function (v) { return v }) || ''
}

export default {
  name: 'MailV2TemplateSelector',
  components: { EcComboSelect },
  props: {
    value: { type: String, default: null },
    holderType: { type: String, required: true },
    holderId: { type: [String, Number], required: true },
    disabled: { type: Boolean, default: false },
    locale: { type: String, default: 'fr' },
  },
  data: function () {
    return {
      store: useMailV2Store(),
      loading: false,
    }
  },
  computed: {
    options: function () {
      var self = this
      return (this.store.templates || []).map(function (item) {
        return {
          value: item.code,
          label: getTranslatable(item.type_name, self.locale) || item.code,
        }
      })
    },
  },
  watch: {
    holderType: function () {
      this.loadTemplates()
    },
    holderId: function () {
      this.loadTemplates()
    },
  },
  mounted: function () {
    this.loadTemplates()
  },
  methods: {
    async loadTemplates() {
      this.loading = true
      try {
        await this.store.listTemplates(this.holderType, this.holderId)
      } finally {
        this.loading = false
      }
    },
    onSelect: function (value) {
      this.$emit('input', value || null)
      var self = this
      var selected = (this.store.templates || []).find(function (item) { return item.code === value })
      if (selected) {
        self.$emit('selected', selected)
      }
    },
  },
}
</script>

<template>
  <EcComboSelect
    :value="value || ''"
    :options="options"
    :placeholder="$ecTranslate('MV2.SELECT_TEMPLATE')"
    :disabled="disabled || loading"
    @input="onSelect"
  />
</template>
